import { createApp } from 'vue'
import App from './App.vue'
import commonContent from '@/components/common/commonContent'
import router from './router'

const app =  createApp(App).use(router)
app.component("c_content",commonContent);
app.mount('#app')
